import styled from "styled-components";

interface UserDisplayData {
  full_name?: string;
  title?: string;
}

const UserSelectBoxItem = ({ data }: { data: UserDisplayData }) => {
  return (
    <div>
      <StyledUserName>{data?.full_name}</StyledUserName>
      <StyledUserInfo>{data?.title || ""}</StyledUserInfo>
    </div>
  );
};

const StyledUserName = styled.div`
  margin-bottom: 5px;
`;

const StyledUserInfo = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 11px;
`;

export default UserSelectBoxItem;
